function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { forwardRef } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useStyle } from "./Checkbox.style";
var Checkbox = forwardRef(function(_param, ref) {
    var accessibilityLabel = _param.accessibilityLabel, checked = _param.checked, describedBy = _param.describedBy, disabled = _param.disabled, id = _param.id, hasError = _param.hasError, indeterminate = _param.indeterminate, name = _param.name, required = _param.required, value = _param.value, children = _param.children, testID = _param.testID, isRtl = _param.isRtl, focused = _param.focused, rest = _objectWithoutProperties(_param, [
        "accessibilityLabel",
        "checked",
        "describedBy",
        "disabled",
        "id",
        "hasError",
        "indeterminate",
        "name",
        "required",
        "value",
        "children",
        "testID",
        "isRtl",
        "focused"
    ]);
    var _$ref = useStyle({
        disabled: disabled,
        indeterminate: indeterminate,
        checked: checked,
        hasError: hasError,
        isRtl: isRtl
    }), label = _$ref.label, input = _$ref.input, checkboxContainer = _$ref.checkboxContainer, icon = _$ref.icon, indeterminateIcon = _$ref.indeterminateIcon;
    var renderCheckbox = function() {
        return _jsxs("div", {
            css: checkboxContainer,
            "aria-hidden": "true",
            children: [
                checked && _jsx("svg", {
                    css: icon,
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 16 16",
                    children: _jsx("path", {
                        d: "M2.90376758,8.34870587 C2.69875098,8.14368927 2.69875098,7.81127814 2.90376758,7.60624103 L3.64621191,6.86377618 C3.85122852,6.65873907 4.18366016,6.65873907 4.38867676,6.86377618 L6.6875,9.16257892 L11.6113232,4.23877618 C11.8163398,4.03375958 12.1487715,4.03375958 12.3537881,4.23877618 L13.0962324,4.98124103 C13.301249,5.18625763 13.301249,5.51866876 13.0962324,5.72370587 L7.05873242,11.7612264 C6.85369531,11.966243 6.52128418,11.966243 6.31626758,11.7612059 L2.90376758,8.34870587 Z"
                    })
                }),
                !checked && indeterminate && _jsx("svg", {
                    css: indeterminateIcon,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    children: _jsx("rect", {
                        width: "8",
                        height: "2",
                        x: "4",
                        y: "7",
                        rx: ".5"
                    })
                })
            ]
        });
    };
    var renderLabelContent = function() {
        if (!children) {
            return '';
        }
        return children;
    };
    var _$ref1, _$ref2;
    return _jsxs("label", {
        htmlFor: id,
        css: label,
        children: [
            _jsx("input", _objectSpread({}, rest, {
                ref: ref,
                css: input,
                "aria-label": (_$ref1 = rest['aria-label']) !== null && _$ref1 !== void 0 ? _$ref1 : accessibilityLabel,
                "aria-describedby": (_$ref2 = rest['aria-describedby']) !== null && _$ref2 !== void 0 ? _$ref2 : describedBy,
                "aria-invalid": !!hasError,
                id: id,
                name: name,
                type: "checkbox",
                value: value,
                checked: checked,
                disabled: disabled
            }, required ? {
                required: true
            } : {}, injectTestId(testID))),
            renderCheckbox(),
            renderLabelContent()
        ]
    });
});
export { Checkbox };
export default Checkbox;
